import styled, { css } from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 54px 28px;
        gap: 40px;
    `,

    "TitleDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 8px;

        & > h2 {
            ${({ theme }) => theme.font["large-semibold"]};
            width: 100%;
            padding-bottom: 16px;
            margin-bottom: 8px;
            border-bottom: 1px solid ${({ theme }) => theme.color["black"]};
        }
    `,
    "InfoDiv": styled.div`
        display: flex;
        justify-content: space-between;

        & > h2 {
            ${({ theme }) => theme.font["large-medium"]};
            color: ${({ theme }) => theme.color["grey3"]};
        }

        & > p {
            ${({ theme }) => theme.font["large-medium"]};
        }
    `,

    "ContentDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 40px;
    `,
    "QuestionDiv": styled.div`
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 12px;

        & > p {
            ${({ theme }) => theme.font["medium-regular"]};
        }
    `,
    "ChoiceBtn": styled.button`
        text-align: left;
        white-space: pre-wrap;
        display: flex;
        gap: 6px;
        align-items: start;
        ${({ theme }) => theme.font["medium-regular"]};

        ${({ $checked }) => $checked && css`
            ${({ theme }) => theme.font["medium-semibold"]};
            color: ${({ theme }) => theme.color["red"]};
        `}
    `,
}